const STORAGE_KEY = "used_filters";

let filters = [];
try {
	filters = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
} catch (e) {
	console.error(e);
}

filters = Array.isArray(filters) ? filters : [];

export function addFilter(filter) {
	let index = filters.findIndex(
		f => f.name === filter.name && f.value === filter.value,
	);
	if (index >= 0) {
		filters[index].lastMod = new Date(Date.now()).toString();
		filters[index].counter += 2;
	} else {
		filter.lastMod = new Date(Date.now()).toString();
		filter.counter = 2;
		filters.push(filter);
	}

	filters.sort(sortImportance);
	localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}

export function removeFilter(filter) {
	let index = filters.findIndex(
		f => f.name === filter.name && f.value === filter.value,
	);
	if (index >= 0 && filters[index].counter > 0) {
		filters[index].counter -= 1;
		filters.sort(sortImportance);
		localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
	}
}

function sortImportance(a, b) {
	if (a.counter === b.counter) {
		return new Date(b.lastMod).valueOf() - new Date(a.lastMod).valueOf();
	}
	return b.counter - a.counter;
}

function isNotExpired(filter) {
	let dateOfExpiry = new Date(filter.lastMod);
	dateOfExpiry.setMonth(dateOfExpiry.getMonth() + 3);
	return dateOfExpiry > new Date(Date.now());
}

export const getUsedFilters = () => {
	return filters.filter(isNotExpired);
};
